import company from './reducers';

export { default as companyActions } from './actions';
export { default as companyTypes }   from './types';

export default company;
